import { useMutation, useQueryClient } from "@tanstack/react-query";

import { newToastEvent } from "../../../utils/ToastUtil";
import { AppConfirm } from "../../../utils/PopupUtil";
import API from "../../api/API";

interface MutationProps {
  supportTargetCloudID: string;
  cloudBackupsQuantity: number;
}

/**
 * Only for supportal
 */
const useCleanCloudBackups = () => {
  const queryClient = useQueryClient();

  const confirmClearCloudBackups = async (quantity: number) => {
    const result = await AppConfirm({
      title: "Confirm Cloud Backups Deletion",
      text: `Are you sure you want to delete all cloud backups except for the last ${quantity}?`,
    });

    return result.isConfirmed;
  };

  const clearCloudBackups = useMutation({
    mutationFn: async ({
      supportTargetCloudID,
      cloudBackupsQuantity,
    }: MutationProps) => {
      return API.cleanCloudBackups(supportTargetCloudID, cloudBackupsQuantity);
    },
    onSuccess: (data, { supportTargetCloudID }) => {
      queryClient.invalidateQueries({
        queryKey: [supportTargetCloudID, "records", "CloudBackups"],
      });

      newToastEvent("success", data?.data.message);
    },
    onError: () => {
      const errorMessage =
        "You don't have permissions to delete a cloud backup.";
      newToastEvent("error", errorMessage);
    },
  });

  return {
    confirmClearCloudBackups: confirmClearCloudBackups,
    cleanCloudBackups: clearCloudBackups.mutate,
    cleanCloudBackupsLoading: clearCloudBackups.isPending,
    cleanCloudBackupsError: clearCloudBackups.isError,
  };
};

export default useCleanCloudBackups;
